import React from "react";
import { formatPrice } from "../../../utils/formatPrice";

const CartItemsListing = ({ calculations, cart }) => {
  const calculateSubTotal = (price, tax, quantity) => {
    const taxAmount = (price * tax) / 100;
    return (price + taxAmount) * quantity;
  };

  const calculateSalesTax = (price, tax) => {
    return (price * tax) / 100;
  };

  return (
    <div>
      <h3>Items Listing</h3>

      <table className="table cart-table table-responsive-xs">
        <thead>
          <tr className="table-head">
            <th scope="col">Media</th>
            <th scope="col">Name</th>
            <th scope="col">Price</th>
            <th scope="col">Tax</th>
            <th scope="col">Qty</th>
            <th scope="col">Total</th>
          </tr>
        </thead>
        <tbody>
          {cart.map((item) => {
            const { product = {}, quantity = 1 } = item;
            const {
              product_name = "",
              product_price = 0,
              sales_tax = 0,
              product_images = [],
            } = product;

            const taxAmount = calculateSalesTax(product_price, sales_tax);
            const subtotal = calculateSubTotal(
              product_price,
              sales_tax,
              quantity
            );

            return (
              <tr key={item._id}>
                <td>
                  <img
                    src={product_images?.[0]?.image}
                    alt={product_name}
                    style={{
                      width: "70px",
                      height: "70px",
                      objectFit: "scale-down",
                    }}
                  />
                </td>
                <td>{product_name}</td>
                <td>{formatPrice(product_price)}</td>
                <td>{formatPrice(taxAmount)}</td>
                <td>{quantity}</td>
                <td>{formatPrice(subtotal)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>

      <hr />

      <div className="order-box">
        <ul className="sub-total">
          <li>
            Subtotal
            <span className="count text-right">
              {formatPrice(calculations?.totalProductPrice)}
            </span>
          </li>
          <li>
            Sales Tax
            <div className="shipping text-right">
              <label htmlFor="sales_tax" className="mb-0">
                {formatPrice(calculations?.totalSalesTax)}
              </label>
            </div>
          </li>
          <li>
            Delivery Charges
            <div className="shipping text-right">
              <label htmlFor="deliveryCharges" className="mb-0">
                {formatPrice(calculations?.totalDeliveryCharges)}
              </label>
            </div>
          </li>
          {/* <li>
            Transaction Fee
            <div className="shipping text-right">
              <label htmlFor="deliveryCharges" className="mb-0">
                {formatPrice(calculations?.transactionFee)}
              </label>
            </div>
          </li> */}
        </ul>
        <ul className="total">
          <li>
            Grand Total
            <span className="count text-right">
              {formatPrice(calculations?.grandTotal)}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default CartItemsListing;
